var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinFilledStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#52BAD5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.201 18.065l4.53-5.012 1.92 1.814-5.31 4.274a.84.84 0 01-.54.179.814.814 0 01-.726-.445.731.731 0 01.113-.81H3.2zm3.914-9.973a.858.858 0 00-.787.5c-.132.3-.06.646.182.878l6.934 6.547c.245.229.612.297.93.172a.81.81 0 00.529-.743v-3.273l3.017-2.849.54.51c.228.215.545.323.865.295.32-.028.61-.19.791-.44a1.055 1.055 0 00-.162-1.326l-5.321-5.037a1.165 1.165 0 00-1.41-.159 1.011 1.011 0 00-.466.748.988.988 0 00.312.816l.54.51-3.028 2.851H7.115zM12.299 17l-.045 2.104L14 20.358l-2.015.627L11.313 23l-1.209-1.746H8l1.254-1.657-.672-2.015 2.015.672z"
  }))));
}
export default SvgPinFilledStar;